var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "rotate(90 16 16)",
    fill: "#8A49D6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_31783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0039 17.4975L17.6062 15.9988L15.0039 14.5V17.4975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8C11.5824 8 8 11.5824 8 16C8 20.4176 11.5824 24 16 24C20.4176 24 24 20.4176 24 16C24 11.5824 20.4176 8 16 8ZM20.9987 16.0082C20.9987 16.0082 20.9987 17.6306 20.793 18.413C20.6776 18.8412 20.34 19.1788 19.9117 19.2941C19.1294 19.5 16 19.5 16 19.5C16 19.5 12.8788 19.5 12.0883 19.2859C11.66 19.1707 11.3224 18.8329 11.207 18.4047C11.0011 17.6306 11.0011 16 11.0011 16C11.0011 16 11.0011 14.3777 11.207 13.5953C11.3223 13.1671 11.6682 12.8212 12.0883 12.7059C12.8706 12.5 16 12.5 16 12.5C16 12.5 19.1294 12.5 19.9117 12.7141C20.34 12.8293 20.6776 13.1671 20.793 13.5953C21.0071 14.3777 20.9988 16.0082 20.9988 16.0082L20.9987 16.0082Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_31783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeContact);
export default __webpack_public_path__ + "static/media/Youtube-Contact.7214a54645f2ac224c3d3b031d4c156c.svg";
export { ForwardRef as ReactComponent };